<template lang="pug">
  .dialog-container(id="ExtensionConfigEditor-dialog")
    .header(v-if='deviceDesktopId && medium && medium.name')
      span {{ medium.name }}&nbsp;-&nbsp;
      span {{ $t('Set your configuration') }}&nbsp;{{$t('for')}}&nbsp;{{ getFullDeviceNameByDesktopId(deviceDesktopId) }}
    .header(v-if='!deviceDesktopId')
      span(v-if='playListItem') {{ $t('Playitem override defaults')}}
      span(v-if='!playListItem') {{ $t('Extension defaults')}}
    span(id="ext-config-medium-id", :data-mediumid='mediumId')
    FormSchema(id="ExtensionConfigEditor-form" ref="formSchema", v-model='model', @submit.native.prevent='submit', :schema="configSchema" :components="components")
      el-button.float-right(id="ExtensionConfigEditor-submitButton" type='success', native-type="submit", size="mini", :disabled='saving') {{ !saving ? $t('Save') : $t('saving...')}}
    br
    br
</template>

<script>
import Vue from 'vue'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import MediumIcon from '../Common/MediumIcon'
import FormSchema from '../../FormSchema.esm.min.js'

import { FormSchemaElementUI } from '../FormSchemaElementUI'

export default {
  mixins: [textUtils, mediaUtils],
  props: ['mediumId', 'playListItem', 'deviceDesktopId', 'extensionConfigForDeviceDesktop'],
  components: {
    MediumIcon,
    FormSchema
  },
  async created () {
    this.loadData()
  },
  watch: {
  },
  data () {
    return {
      errors: {
      },
      components: new FormSchemaElementUI(),
      medium: undefined,
      configSchema: {},
      model: {},
      saving: false
    }
  },
  methods: {
    async loadData () {
      let mediumLoaded
      let fileLoaded
      // mediumId can be also playListItem.MediumId
      if (this.playListItem && this.playListItem.MediumId) {
        this.playListItem.Medium = { id: this.playListItem.MediumId }
      }
      const mediumId = this.playListItem ? this.playListItem.Medium.id : this.mediumId
      await Vue.axios
        .get(`medium/${mediumId}`)
        .then(response => {
          mediumLoaded = response.data
        })
      await Vue.axios
        .get(`file/${mediumLoaded.File.id}`)
        .then(response => {
          fileLoaded = response.data
        })
      mediumLoaded.File = fileLoaded
      this.medium = mediumLoaded
      this.model = Object.assign(
        {},
        this.medium.extensionConfig,
        this.playListItem ? this.playListItem.extensionConfig : {},
        this.extensionConfigForDeviceDesktop ? this.extensionConfigForDeviceDesktop : {}
      )
      this.configSchema = JSON.parse(mediumLoaded.File.Extension.configSchemaText)
    },
    async submit () {
      if (this.deviceDesktopId) {
        this.__saveExtensionPlayitemDeviceDesktopConfig()
        return
      }
      const path = this.playListItem ? `playlistitem/${this.playListItem.id}` : `medium/${this.medium.id}`
      this.saving = true
      await Vue.axios.patch(path, { extensionConfig: this.model })
      this.$emit('close')
      this.saving = false
    },
    async __saveExtensionPlayitemDeviceDesktopConfig () {
      this.saving = true
      await Vue.axios.post(`ExtensionPlayitemDeviceDesktopConfig/createOrUpdate`, {
        extensionConfig: this.model,
        path: this.playListItem.path,
        DeviceDesktop: this.deviceDesktopId,
        PlayListItem: this.playListItem.PlayListItemId
      })
      this.$emit('close')
      this.saving = false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.header {
  font-size: $--font-size-big;
  font-weight: bold;
}
div[data-fs-kind="array"] > label {
  font-weight: bold;
  font-size: $--font-size-big !important;
  width: 100%;
  text-align: center;
  display: inline-block;
  margin-bottom: 30px;
}
div[data-fs-kind="array"] {
  border: 1px solid $--color-warning;
  border-radius: 5px;
  margin-bottom: 40px;
  margin-top: 10px;
  padding: 10px;
}
div[data-fs-input="array"] > div[data-fs-kind="object"] > div[data-fs-input="object"] {
  border-top: 2px solid $--border-color-extra-light;
  margin-top: 10px;
  margin-bottom: 100px;
}

div[data-fs-input="array"] {
  counter-reset: item-counter;
}
div[data-fs-input="array"] > div[data-fs-kind="object"] {
  counter-increment: item-counter;
}
div[data-fs-input="array"] > div[data-fs-kind="object"] > div[data-fs-input="object"]::before {
  content: "#" counter(item-counter);
  margin: 0 auto;
  display: block;
  width: 6em;
  font-weight: bold;
  color: $--color-warning;
  text-align: center;
  padding: 5px;
  background: #191a1c;
  margin-top: -1em;
}

.array-buttons[data-fs-buttons] {
  text-align: right;
}

.el-form-item__content > div[data-fs-buttons="3"]  {
  float: right;
  // margin-top: -35px;
  color: #c0c0c0;
  font-size: 12px;
  margin-left: 8px;
}

div[data-fs-input="object"] >  div[data-fs-buttons="3"]  {
  float: right;
  margin-top: -35px;
}

div[data-fs-kind="object"] {
  margin-bottom: 60px;
}

div[class="el-autocomplete"] {
  width: 100%;
}

span[data-fs-helper="true"] {
  color: #797979;
  font-size: 12px;
  margin-left: 8px;
}

#ExtensionConfigEditor-form {
  p[data-fs-helper="true"] {
    color: $--color-text-secondary;
    font-size: 12px;
    margin-bottom: 28px;
    padding-bottom: 10px;
    border-bottom: 1px solid $--color-text-secondary;
  }
  .el-form-item {
    height: 50px;
    margin: 0px 0px 10px 0px;
    // padding: 0;
    .el-form-item__label {
      font-weight: bold;
      font-size: $--font-size-base;
      color: $--color-text-secondary;
      white-space: nowrap;
      min-width: 200px;
    }
    .el-form-item__label::after {
      font-weight: bold;
      content: ":";
    }
    border-bottom: $--border-light;
    .el-form-item__content {
      font-size: $--font-size-base;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      span[data-fs-helper="true"] {
        display: none;
      }
      div[data-fs-type="radio"] {
        label {
          width: 200px;
          height: 10px;
          margin-bottom: 10px;
          overflow-x: visible;
          float: right;
        }
      }
      .el-checkbox {
        margin-right: 77%;
      }
    }
  }
  .el-button--info {
    background-color: $--color-success;
    color: $--color-text-primary;
    // font-weight: bold;
    // font-size: $--font-size-big;
    border: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/ExtensionConfigEditor.vue